import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, 
  Button, Typography, Box
} from '@mui/material';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';

const ConfirmDialog = ({ 
  open, 
  title, 
  content, 
  onConfirm, 
  onClose, 
  confirmText = "Xác nhận", 
  cancelText = "Hủy bỏ",
  confirmColor = "primary" // 'primary', 'error', 'warning'...
}) => {
  
  // Map màu sắc cho icon và nút confirm
  const colorMap = {
    primary: '#007373',
    error: '#d32f2f',
    warning: '#ed6c02',
    info: '#0288d1'
  };
  
  const mainColor = colorMap[confirmColor] || confirmColor;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="confirm-dialog-title"
      aria-describedby="confirm-dialog-description"
      maxWidth="sm" // Tăng độ rộng tối đa lên Small (thay vì xs mặc định khá bé)
      fullWidth     // Bắt buộc bung full chiều rộng của maxWidth
      PaperProps={{
        sx: { 
          borderRadius: 3, // Bo góc mềm mại hơn
          padding: 1,
          boxShadow: '0 8px 24px rgba(0,0,0,0.15)' 
        }
      }}
    >
      <DialogTitle id="confirm-dialog-title" sx={{ pb: 1 }}>
        <Box display="flex" alignItems="center" gap={1.5}>
          {/* Icon cảnh báo */}
          <WarningAmberRoundedIcon sx={{ fontSize: 32, color: mainColor }} />
          <Typography variant="h6" fontWeight="bold" sx={{ color: '#333' }}>
            {title}
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent>
        <DialogContentText 
          id="confirm-dialog-description" 
          sx={{ 
            fontSize: '1rem', 
            color: '#555', 
            lineHeight: 1.6,
            mt: 1 
          }}
        >
          {content}
        </DialogContentText>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button 
          onClick={onClose} 
          variant="outlined"
          color="inherit" 
          sx={{ 
            fontWeight: 'bold', 
            textTransform: 'none',
            px: 3,
            borderRadius: 2,
            borderColor: '#ccc',
            color: '#666'
          }}
        >
          {cancelText}
        </Button>
        <Button 
          onClick={onConfirm} 
          variant="contained" 
          autoFocus
          sx={{ 
            bgcolor: mainColor,
            '&:hover': { bgcolor: mainColor, filter: 'brightness(0.9)' },
            fontWeight: 'bold',
            textTransform: 'none',
            px: 4,
            py: 0.8,
            borderRadius: 2,
            boxShadow: 'none'
          }}
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;